import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import {
  LinkWithGAClickButton,
  Section,
} from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import {
  WINDOWS_CDN_PATH,
  WINDOWS_ELEMENT_BLOCK,
} from '../../windows-constants';

const podcastBanner = css`
  width: 100%;
`;

export const WindowsBanner: React.FC<{ className: string }> = ({ className }) => (
  <Section className={cn(podcastBanner, className)}>
    <LinkWithGAClickButton
      elementBlock={WINDOWS_ELEMENT_BLOCK}
      elementName="Узнайте всё про окна в нашем подкасте"
      elementText="Глаза дома: все, что нужно знать об окнах | Подкаст «Дом для жизни»"
      href="https://dzen.ru/video/watch/69030e95dedfba7e86abe861?share_to=link"
      target="_blank"
      title="Глаза дома: все, что нужно знать об окнах | Подкаст «Дом для жизни»"
    >
      <picture>
        <source srcSet={`${WINDOWS_CDN_PATH}/banners/podcast-ld.jpg/podcast-ld.jpg`} media={strictBreakpoints['--only-largeDesktop']} />
        <source srcSet={`${WINDOWS_CDN_PATH}/banners/podcast-d.jpg/podcast-d.jpg`} media={strictBreakpoints['--only-desktop']} />
        <source srcSet={`${WINDOWS_CDN_PATH}/banners/podcast-t.jpg/podcast-t.jpg`} media={strictBreakpoints['--only-tablet']} />
        <img
          alt="Баннер подкаста"
          className={podcastBanner}
          src={`${WINDOWS_CDN_PATH}/banners/podcast-m.jpg/podcast-m.jpg`}
        />
      </picture>
    </LinkWithGAClickButton>
  </Section>
);
